export default __webpack_public_path__ + "static/new-patient-form-SDA-7e1799a196f6b4ef365c7aed0f4d9555.pdf";